import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=74c791a7&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=ts&"
export * from "./Success.vue?vue&type=script&lang=ts&"
import style0 from "./Success.vue?vue&type=style&index=0&id=74c791a7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c791a7",
  null
  
)

export default component.exports